<script lang="ts" setup>
import './textpages.scss';
import { useRouter, useRoute } from 'vue-router'
import { onMounted, ref, watch, nextTick } from 'vue';
import { useUserStore } from '@/stores/user';
import { useLocalizationStore } from '@/stores/localization';
import { storeToRefs } from 'pinia';

import config from '@/config';

import promos from '@/views/textpages/promos/promos.vue';
import contact from '@/views/textpages/contact/contact.vue';
import help from '@/views/textpages/help/help.vue';
import notfound from '@/views/textpages/404/404.vue';

const { language } = storeToRefs(useLocalizationStore());

const pageTitle = ref('');
const pageText = ref(undefined);
const pages: any = ref(['help', 'promos', 'contact', 'cookies', 'terms', 'policy', '404', 'us2257']);

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();

onMounted(load);

async function load() {
    await router.isReady();
    await getPageData();
}

function getText(data: any){
    const lang = language!.value ? language!.value : 'en';
    return data[lang];
}

async function getPageData(to?: any){
    const newRoute = to ? to : route;
    pageTitle.value = newRoute.name ? newRoute.name.toLowerCase() : '';
    const page = newRoute.name ? newRoute.name.toLowerCase() : false;

    const response = await fetch(`/themes/${config.Themename}/assets/textpages/${page}.data.json`);
    pageText.value = await response.json();
}

watch(
    () => route.fullPath,
    async () => {
        if(pages.value.includes(route.name as string)){
            getPageData();
        }
    }
);

</script>

<template>
    <div class="page">
        <div class="container">
            <div class="textpages" :class="{'textpages--mobile': userStore.mobile}">
                <div class="textpages__header">
                    <h1 v-if="pageTitle">{{ $t('textpages.' + pageTitle + 'title') }}</h1>
                </div>

                <div v-if="pageText">
                    <promos v-if="pageTitle === 'promos'" :page-data="getText(pageText)"></promos>
                    <contact v-if="pageTitle === 'contact'" :page-data="getText(pageText)"></contact>
                    <help v-if="pageTitle === 'help'" :page-data="getText(pageText)"></help>
                    <notfound v-if="pageTitle === '404'" :page-data="getText(pageText)"></notfound>

                    <div v-if="(pageTitle !== 'promos' && pageTitle != 'contact' && pageTitle !== '404')" class="textpages__content">
                        <div class="textpages__content-col0" v-html="getText(pageText)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>